import styled from 'styled-components';

export const StyledLink = styled.a`
    display: block;
    font-weight: bold;
    margin: 10px 0;
`;
